import {Directive, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatButtonToggle} from '@angular/material/button-toggle';
import {FieldConfigWrapper} from "../../dynamic-field/field-config-wrapper";
import {ButtonToggleFieldConfig} from "./button-toggle.config";

@Directive({
    selector: 'mat-button-toggle[formControlName], mat-button-toggle[formControl]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MatButtonToggleValueAccessor),
            multi: true,
        },
    ],
})
export class MatButtonToggleValueAccessor implements ControlValueAccessor, OnInit {
    @Input() setChecked: boolean;
    @Input() control: UntypedFormGroup;
    @Input() item: any;
    @Input() fieldWrapper: FieldConfigWrapper<ButtonToggleFieldConfig>

    constructor(private host: MatButtonToggle) {
    }

    onChange: (value: any) => void = () => {

    };

    onTouched: () => void = () => {
    };

    writeValue(value: any): void {
        this.host.checked = value;
    }

    registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
        this.host.change.subscribe((source) => {
            if (!this.fieldWrapper.config.multiSelect) {
                Object.keys(this.control.controls).forEach(value => {
                    if (value !== this.item.key) {
                        this.control.get(value).setValue(false, {emitEvent: false})
                    }
                })
            }

            this.onChange(source.source.checked);
        });
    }


    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.host.disabled = isDisabled;
    }

    ngOnInit(): void {
        if (this.setChecked) {
            this.control.get(this.item.key).setValue(true, {emitEvent: false})
        }
    }
}
